import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Task M3: WorkspaceLiveTradingContext — shared LIVE broker cho multi-chart.
 *
 * Mirror WorkspaceReplayTradingContext nhưng cho LIVE (không reset theo symbol,
 * namespace riêng cấp workspace). Single-chart không bị ảnh hưởng (dùng optional hook).
 */
import { createContext, useContext } from "react";
const defaultValue = undefined;
export const WorkspaceLiveTradingContext = createContext(defaultValue);
export function WorkspaceLiveTradingProvider({ value, children, }) {
    return _jsx(WorkspaceLiveTradingContext.Provider, { value: value, children: children });
}
export function useWorkspaceLiveTradingContext() {
    const ctx = useContext(WorkspaceLiveTradingContext);
    if (ctx === defaultValue) {
        throw new Error("useWorkspaceLiveTradingContext must be used within WorkspaceLiveTradingProvider");
    }
    return ctx;
}
export function useOptionalWorkspaceLiveTrading() {
    const ctx = useContext(WorkspaceLiveTradingContext);
    return ctx === defaultValue ? undefined : ctx;
}
